import { z } from 'zod';
import { GetJsonDocumentError } from 'libs/end-to-end/src/types/errors/get-json-document-error';

export const GetAllDatabasesAndRevisionsError = GetJsonDocumentError;

export type GetAllDatabasesAndRevisionsError = z.infer<
  typeof GetAllDatabasesAndRevisionsError
>;
